"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderGridLayout = renderGridLayout;
exports.getGridStyles = getGridStyles;
exports.registerGridLayout = exports.BmGridLayout = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _layoutRegistry = require("../../registry/layout-registry");

var _renderLayout = require("./render-layout");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t<bm-grid-layout\n\t\t\t.info=\"", "\"\n\t\t\t.items=\"", "\"\n\t\t\tstyle=\"", "\"\n\t\t></bm-grid-layout>\n\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div\n\t\t\t\tclass=\"field\"\n\t\t\t\tdata-name=\"", "\"\n\t\t\t\tstyle=\"", "\">\n\t\t\t\t", "\n\t\t\t</div>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t", "\n\t\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t:host {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: repeat(var(--cols-count), 1fr);\n\t\t\t\tgrid-template-rows: repeat(var(--rows-count), auto);\n\t\t\t\tgrid-gap: var(--gap, 0);\n\t\t\t}\n\n\t\t\t:host > .field {\n\t\t\t\tgrid-column-start: var(--field-col-start);\n\t\t\t\tgrid-column-end: var(--field-col-end);\n\t\t\t\tgrid-row-start: var(--field-row-start);\n\t\t\t\tgrid-row-end: var(--field-row-end);\n\t\t\t}\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmGridLayout = /*#__PURE__*/function (_BmFormLayout) {
  (0, _inherits2.default)(BmGridLayout, _BmFormLayout);

  var _super = (0, _createSuper2.default)(BmGridLayout);

  (0, _createClass2.default)(BmGridLayout, null, [{
    key: "is",
    get: function get() {
      return 'bm-grid-layout';
    }
  }, {
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject());
    }
  }]);

  function BmGridLayout() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmGridLayout);
    _this = _super.call(this);
    _this.renderField = (0, _bind.default)(_context = _this.renderField).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmGridLayout, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changes) {
      if (!this.info || !this.items) return false;
      var position = this.info.options.position;
      this.cachedSortedPositions = this.sortPositions(position);
      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmGridLayout.prototype), "shouldUpdate", this).call(this, changes);
    }
  }, {
    key: "sortPositions",
    value: function sortPositions(position) {
      var _context2, _context3;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$baseCol = _ref.baseCol,
          baseCol = _ref$baseCol === void 0 ? 0 : _ref$baseCol,
          _ref$baseRow = _ref.baseRow,
          baseRow = _ref$baseRow === void 0 ? 0 : _ref$baseRow;

      return (0, _sort.default)(_context2 = (0, _map.default)(_context3 = (0, _entries.default)(position)).call(_context3, function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            _ = _ref3[0],
            pos = _ref3[1];

        return [_, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, pos), {}, {
          colSpan: (pos.colSpan || 0) + baseCol,
          rowSpan: (pos.rowSpan || 0) + baseRow
        })];
      })).call(_context2, function (_ref4, _ref5) {
        var _ref6 = (0, _slicedToArray2.default)(_ref4, 2),
            posA = _ref6[1];

        var _ref7 = (0, _slicedToArray2.default)(_ref5, 2),
            posB = _ref7[1];

        var colSpanA = posA.colSpan,
            rowSpanA = posA.rowSpan;
        var colSpanB = posB.colSpan,
            rowSpanB = posB.rowSpan;
        var differentRows = rowSpanA - rowSpanB;
        return differentRows || colSpanA - colSpanB;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var gridPositions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.cachedSortedPositions;
      return this.html(_templateObject2(), (0, _repeatInstanceProperty(_element))(gridPositions, function (_ref8) {
        var _ref9 = (0, _slicedToArray2.default)(_ref8, 1),
            name = _ref9[0];

        return name;
      }, this.renderField));
    }
  }, {
    key: "renderField",
    value: function renderField(_ref10) {
      var _this2 = this;

      var _ref11 = (0, _slicedToArray2.default)(_ref10, 2),
          name = _ref11[0],
          position = _ref11[1];

      var itemInfo = this.getItem(name);
      return (0, _element.guard)(itemInfo, function () {
        return _this2._renderField(itemInfo, position);
      });
    }
  }, {
    key: "getItem",
    value: function getItem(name) {
      return this.items[name];
    }
  }, {
    key: "_renderField",
    value: function _renderField(itemInfo, _ref12) {
      var _itemInfo$options;

      var rows = _ref12.rows,
          rowSpan = _ref12.rowSpan,
          columns = _ref12.columns,
          colSpan = _ref12.colSpan;
      if (itemInfo.available === false) return null;
      var gridFieldStyles = (0, _element.styleMap)({
        '--field-col-start': (colSpan + 1).toString(),
        '--field-col-end': (colSpan + 1 + columns).toString(),
        '--field-row-start': (rowSpan + 1).toString(),
        '--field-row-end': (rowSpan + 1 + rows).toString(),
        visibility: ((_itemInfo$options = itemInfo.options) === null || _itemInfo$options === void 0 ? void 0 : _itemInfo$options.hiddenField) ? 'hidden' : 'visible'
      });
      var name = itemInfo.name;
      return this.html(_templateObject3(), name, gridFieldStyles, this.renderItem(itemInfo));
    }
  }], [{
    key: "dependents",
    value: function dependents(info) {
      return (0, _keys.default)(info.options.position);
    }
  }]);
  return BmGridLayout;
}(_renderLayout.BmFormLayout);

exports.BmGridLayout = BmGridLayout;

function renderGridLayout(info, items) {
  return (0, _element.html)(_templateObject4(), info, items, (0, _element.styleMap)(info ? getGridStyles(info.options) : {}));
}

function getGridStyles(gridLayoutOptions) {
  var _getGridCount = getGridCount(gridLayoutOptions.position),
      rowCount = _getGridCount.rowCount,
      colCount = _getGridCount.colCount;

  var gridStyles = {
    '--cols-count': colCount.toString(),
    '--rows-count': rowCount.toString(),
    '--gap': gridLayoutOptions.gap || '0'
  };
  return gridStyles;
}

function getGridCount(gridPositions) {
  var colCount = 0;
  var rowCount = 0;
  var fields = (0, _values.default)(gridPositions);
  (0, _forEach.default)(fields).call(fields, function (field) {
    colCount = field.columns + (field.colSpan || 0) > colCount ? field.columns + (field.colSpan || 0) : colCount;
    rowCount = field.rows + (field.rowSpan || 0) + 1 > rowCount ? field.rows + (field.rowSpan || 0) + 1 : rowCount;
  });
  return {
    colCount: colCount,
    rowCount: rowCount
  };
}

var registerGridLayout = function registerGridLayout() {
  (0, _layoutRegistry.registerLayout)('grid', {
    renderer: renderGridLayout,
    dependents: BmGridLayout.dependents
  });
  (0, _element.register)(BmGridLayout);
};

exports.registerGridLayout = registerGridLayout;
